// Backend responde 402 + ERR_LICENSE_EXPIRED a toda chamada autenticada de
// empresa com licenca vencida (fora da allowlist de pagamento).
export const ehLicencaVencida = (error) =>
	error?.response?.status === 402 &&
	error.response.data?.error === "ERR_LICENSE_EXPIRED";
